<template>
	<v-card>
		<template v-if="isLoading">
			<div class="text-xs-center pa-5">
				<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
				<div class="caption mt-4">{{loadingText}}</div>
			</div>
		</template>
		<template v-if="!isLoading">
			<v-card-title>
				<span class="headline">Yeni Bir Domain Oluştur</span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap> 
						<v-flex xs12  >
							<v-text-field v-model="domainName" label="Domain (Örn: site.com)" hint="Kullanıcı adı ve şifre otomatik oluşturulacak" persistent-hint required></v-text-field>
						</v-flex>  
						<v-flex xs12  >
							<v-select v-model="packageName" :items="getPackages"  item-text="text" item-value="value" label="Hosting Paketi" required></v-select>
						</v-flex> 
					</v-layout>
				</v-container> 
			</v-card-text>
			<v-card-actions class="pr-4 pl-4 pb-4">
				<v-btn round outline  color="error" dark @click="closeMe(false)">Vazgeç</v-btn>
				<v-spacer></v-spacer> 
				<v-btn round  disabled v-if="creatableStatus == 'none'">Domain belirle</v-btn>
				<v-btn round color="error"   disabled v-if="creatableStatus == 'already'">Bu domain olmaz</v-btn>
				<v-btn round color="primary" dark v-if="creatableStatus == 'canbe'" @click="createAccount()">Oluştur</v-btn> 
			</v-card-actions>
		</template>
	</v-card>
</template>


<script>
export default {
	name : 'ServerAccountNewAccount',
	props : ['accounts'],
	data : () => ({
		isLoading : true,
		loadingText : "",
		packages : [],
		domainName : "",
		packageName : "default",
	}),
	mounted(){
		this.loadingText = "Paket listesi yükleniyor"
		this.loadPackages();
	},
	methods : {
		loadPackages(){
			this.isLoading = true; 
			this.$http.get( process.env.VUE_APP_API_URL + "/server/packages/", {
				params : { }
			}).then(response => {  
				this.packages = response.body;
				this.isLoading = false; 
			}) 
		},
		createAccount(){
			this.loadingText = "Domain oluşturuluyor"
			this.isLoading = true;
			this.$http.post(process.env.VUE_APP_API_URL + "/server/accounts/add", {
				domain : this.domainName,
				package : this.packageName
			}, {
				params: { }
			}).then(response => { 
				this.isLoading = false;
				this.closeMe(true) 
			})
		},
		closeMe(e){
			this.$emit("closeMe",e)
		}
	},
	computed : {
		getPackages(){
			var packages = [];
			for(var i in this.packages){
				var p = this.packages[i] 
				var name = p.name;
				if(p.BWLIMIT){
					name += " - ";
					name += parseFloat( p.BWLIMIT  / 1000 ).toFixed(0) + "GB"
				}
				if(p.MAXADDON){
					name += " - ";
					name +=  p.MAXADDON + " domain"
				}
				packages.push({
					value : p.name,
					text : name,
				});
			}
			return packages;
		},
		creatableStatus(){
			if(this.domainName == ""){
				return "none"
			}
			var re = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/); 
			if(!this.domainName.match(re)){
				return "none"
			}
			var index = this.accounts.findIndex(item => item.domain == this.domainName);
			if(index > -1){
				return "already"
			}
			return "canbe" 
		}
	}
}
</script>

